<template>
  <div>
    <div class="pw-drawer" :class="{ 'pw-drawer-is-open': value }">
      <div class="pw-drawer-mask" @click="toggle"></div>
      <div class="pw-drawer-content">
        <div class="pw-drawer-wrapper-body">
          <div class="pw-drawer-header">
            <div class="pw-drawer-title">
              {{ title }}
            </div>
          </div>
          <button class="pw-drawer-close" @click="toggle">
            <i class="mdi mdi-close pw-drawer-close-x"></i>
          </button>
          <div class="pw-drawer-body" v-if="value || alwaysLoad">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    value: {
      type: Boolean,
    },
    alwaysLoad: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (max-width: 768px) {
  .pw-drawer {
    &-body {
      & > div {
        width: 100% !important;
      }
    }
    &-content {
      max-width: 80%;
    }
  }
}
.pw-drawer {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  z-index: 1002;
  &-is-open {
    .pw-drawer-content {
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    }
    width: 100%;
    .pw-drawer-content {
      transform: translateX(0);
    }
    .pw-drawer-mask {
      opacity: 0.3;
      height: 100%;
    }
  }
  &-mask {
    width: 100%;
    position: fixed;
    height: 0;
    background-color: rgba(0, 0, 0, 0.65);
    opacity: 0;
    transition: opacity 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);
  }
  &-header {
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;
  }
  &-content {
    position: relative;
    z-index: 1;
  }
  &-close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    outline: none;
  }
  &-close-x {
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
  }
  &-title {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    min-height: 19px;
  }
  &-body {
    padding: 24px;
    height: calc(100vh - 57px);
    overflow-y: auto;
    box-sizing: border-box;
  }
  &-content {
    min-width: 400px;
    position: fixed;
    right: 0;
    height: 100%;

    background-color: #fff;
    background-clip: padding-box;
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.9, 0, 0.3, 0.7),
      -webkit-transform 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);
  }
}
</style>
